import { render, staticRenderFns } from "./ChildCreate.vue?vue&type=template&id=46075013&scoped=true&"
import script from "./ChildCreate.vue?vue&type=script&lang=js&"
export * from "./ChildCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46075013",
  null
  
)

export default component.exports